import { render, staticRenderFns } from "./Remediation.vue?vue&type=template&id=32995c37&scoped=true"
import script from "./Remediation.vue?vue&type=script&lang=js"
export * from "./Remediation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32995c37",
  null
  
)

export default component.exports